<template>
  <div>
    <b-card v-if="isCard">
      <vue-apex-charts
        v-if="series.length"
        type="line"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
    <div v-else>
      <vue-apex-charts
        v-if="series.length"
        type="line"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'InsuranceMixedCharts',
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    isCard: {
      type: Boolean,
      default: true,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          stacked: false,
        },
        stroke: {
          width: [0, 2, 5],
          curve: 'smooth',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
          },
        },

        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100],
          },
        },
        labels: [],
        markers: {
          size: 0,
        },
        yaxis: {
          title: {
            text: 'CSI',
          },
          min: 0,
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter(y) {
              if (typeof y !== 'undefined') {
                return y
              }
              return y
            },
          },
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.labels = this.categoriesData
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
